export default {"src":"/_next/static/media/w_location.96f1eb32.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};